import { useCallback } from "react"

const useLead = () => {
  const trackLead = useCallback(() => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "Lead")
      console.info("Lead event tracked")
    } else {
      console.warn(
        "Facebook Pixel is not available or blocked by an adblocker."
      )
    }
  }, [])

  return trackLead
}

export default useLead
